import Clarity from '@microsoft/clarity';
import { StatsigClient } from '@statsig/react-bindings';

// Pattern borrowed from analytics.js
export const ClarityProxy = new Proxy(
  window.Cypress ? window.incTest.Clarity : Clarity,
  {
    get: function (obj, prop) {
      // Ignore the $$typeof property, which is used by React to identify elements
      // If we don't ignore this, the next line will mess up Statsig
      if (prop === '$$typeof') return;

      // If the clarity gate is not enabled, return a no-op function. Calls to any
      // Clarity method (e.g. ClarityProxy.init, ClarityProxy.identify) will do nothing.
      if (!StatsigClient.instance().checkGate('web-clarity')) return () => {};

      const result = obj[prop];

      // if (result instanceof Function) {
      if (typeof result === 'function') {
        return (...args) => {
          try {
            return result(...args);
          } catch (error) {
            // just squash the error
          }
        };
      }
    },
  },
);
